module.exports = __webpack_public_path__ + "static/img/pdf_green.505ff362.svg";